import { Navigate, Outlet } from 'react-router-dom';
import Cookies from 'universal-cookie';

const cookies = new Cookies(null, { path: '/' });

const isValidToken = (token) => {
  return typeof token === 'string' && token.trim() !== '';
};

const ProtectedRoute = ({ isPrivate }) => {
  const accessToken = localStorage.getItem('access_token');
  const refreshToken = cookies.get('refresh_token');

  const hasValidAccessToken = isValidToken(accessToken);
  const hasValidRefreshToken = isValidToken(refreshToken);

  const isAuthenticated = hasValidAccessToken && hasValidRefreshToken;

  if (isPrivate && !isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  if (!isPrivate && isAuthenticated) {
    return <Navigate to="/dashboards/details" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
